import { MouseEvent, ReactNode, useState } from 'react';
import { CustomAlert, CustomButton } from '../../shared/uiComponents';
import { Info } from '../../shared/Assets/svgIcons';
import { ClientDetailedInfo } from './tableInfo';
import { InfoClientProperties } from '../../redux/API/ClientAPIHelpers/clientProperties';

// TODO: component should be simplified, it uses too many props and types which is not necessary at all

type RenderContentFn<T> = (item: T) => ReactNode;

type BaseProps<T> = {
	defaultOpen?: boolean;
	dialogTitle?: string;
	item: T;
	onToggle?: (open: boolean) => void;
};

type WithCustomContent<T> = {
	RenderContent?: RenderContentFn<T>;
	customContent?: never;
};

type WithDirectContent = {
	RenderContent?: never;
	customContent: ReactNode;
};

type ClientInfoProps = BaseProps<InfoClientProperties> & (WithCustomContent<InfoClientProperties> | WithDirectContent);

export const ClientInfo = ({
	item,
	dialogTitle = 'Detailed Information',
	defaultOpen = false,
	onToggle,
	customContent,
	RenderContent,
}: ClientInfoProps) => {
	const [open, setOpen] = useState<boolean>(defaultOpen);

	const handleOpen = (e?: MouseEvent) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		setOpen(true);
		onToggle?.(true);
	};

	const handleClose = () => {
		setOpen(false);
		onToggle?.(false);
	};

	const renderContent = () => {
		if (customContent) return customContent;
		if (RenderContent) return RenderContent(item);

		return <ClientDetailedInfo {...item} />;
	};

	return (
		<>
			<CustomButton buttonType="secondaryGray" iconOnly={<Info />} onClick={handleOpen} />
			<CustomAlert open={open} onClose={handleClose} title={dialogTitle} Content={() => <>{renderContent()}</>} />
		</>
	);
};
